import { Rect } from "fabric";
import { useEffect } from "react";
import { InteractableCanvasElementProps } from "./Canvas";

type Props = {
  x: number;
  y: number;
  height: number;
  width: number;
  color: string;
  opacity: number;
  draggable: boolean;
  borderStrokeWidth?: number;
} & InteractableCanvasElementProps;

const DefaultStrokeWidth: number = 0.7;

const BorderedRect = (props: Props) => {
  if (props.canvas == null) {
    throw new Error("Canvas Elements must the canvas prop passed");
  }
  useEffect(() => {
    const strokeWidth = props.borderStrokeWidth ?? DefaultStrokeWidth;
    const rect = new Rect({
      height: props.height + strokeWidth,
      width: props.width + strokeWidth,
      left: props.x - strokeWidth,
      top: props.y - strokeWidth,
      fill: "transparent",
      stroke: props.color,
      strokeWidth: strokeWidth,
      hasControls: props.draggable,
      lockMovementX: !props.draggable,
      lockMovementY: !props.draggable,
      lockRotation: true,
      evented: props.evented,
      data: {
        id: props.id,
      },
    });
    rect.setControlVisible("mtr", false);
    props.canvas!.add(rect);
    return function cleanupHighlight() {
      props.canvas!.remove(rect);
    };
  }, [
    props.x,
    props.y,
    props.width,
    props.height,
    props.color,
    props.opacity,
    props.draggable,
    props.borderStrokeWidth,
  ]);

  return null;
};

export { BorderedRect };
